import AWS from 'aws-sdk';
const s3 = new AWS.S3({
  endpoint: process.env.REACT_APP_DO_ENDPOINT,
  accessKeyId: process.env.REACT_APP_DO_ACCESSKEYID,
  secretAccessKey: process.env.REACT_APP_DO_SECRETACCESSKEY,
});

export default s3;
